import ajaxService from '../services/ajaxService';

function showPageViewCountOnNeed(viewCount) {
	if (viewCount < 1) {
		return;
	}

	const $pageViewCountBlock 			= $('.pageViewCountBlock'),
		  $pageViewCountBlockContainer 	= $('#pageViewCountBlockContainer');

	$('.pageViewCount').text(viewCount);
	$pageViewCountBlock.show();
	$pageViewCountBlockContainer.removeClass('d-none');
}

function handlePageView({saveUrl, fetchUrl}) {
	ajaxService.sendPost(
		{
			'url': saveUrl
		},
		{
			'withCsrf': false
		}
	)
	.then(() => {
		ajaxService.sendGet(
			fetchUrl,
			{
				'withAbTests': false
			}
		)
			.then((res) => {
				if (res) {
					showPageViewCountOnNeed(res.viewCount);
				}
			});
	});
}

export {handlePageView};